export const TRIAL_PAGES_PING_PROOF = 'ping_proof';
